let host;

if (process.env.REACT_APP_ENV === 'development') {
	host = "http://localhost:8002"
} else {
	host = "https://dashboard.davrontranslations.com"
}

export const API_ENDPOINT=host
export const CALCULATE_PRICE = 'CALCULATE_PRICE'
export const ADD_FILES = 'ADD_FILES'
export const ADD_FILE_TO_FORM = 'ADD_FILE_TO_FORM'
export const CHANGE_CURRENCY = 'CHANGE_CURRENCY'
export const UPDATE_WORDCOUNT = 'UPDATE_WORDCOUNT'
export const UPDATE_FILE = 'UPDATE_FILE'
export const PRICE_REFRESH_END = 'PRICE_REFRESH_END'
export const PRICE_REFRESH_START = 'PRICE_REFRESH_START'
export const UPDATE_GLOBAL_COUNT = 'UPDATE_GLOBAL_COUNT'
export const UPDATE_PAGECOUNT = 'UPDATE_PAGECOUNT'
export const REMOVE_FILES = 'REMOVE_FILES'
export const SHIPPING_ADDRESS_FILLED = 'SHIPPING_ADDRESS_FILLED'
export const REMOVE_FILE_FROM_FORM = 'REMOVE_FILE_FROM_FORM'
export const UPDATE_PAGES = 'UPDATE_PAGES'
export const SET_LANG = 'SET_LANG'
export const DELETE_DOC = 'DELETE_DOC'
export const SYNC_CONTACT_INFO = 'SYNC_CONTACT_INFO'
export const SAME_ADDRESS_CHANGE = 'SAME_ADDRESS_CHANGE'


// WEBPACK FOOTER //
// ./src/constants.js